import React, {Component} from 'react';
import GraphController from './GraphController'
import GraphWaterController from './GraphWaterController'
import GraphGasController from './GraphGasController'
import { NavLink, Switch, Route } from 'react-router-dom';


export default class DisplayLineGraph extends Component {

  render() {
    return (
      <div className="graph-container">
        <h3 className="graph-header">Over the Months</h3>
        
        <div className="graph-nav">
          <NavLink exact to="/home" aria-label="water graph" className="nav-link sign-nav" activeClassName="active">Water</NavLink>
          <NavLink to="/home/electric" aria-label="electric graph" className="nav-link sign-nav" activeClassName="active">Electricity</NavLink>
          <NavLink to="/home/gas" aria-label="gas graph"className="nav-link sign-nav mr-0" activeClassName="active">Gas</NavLink>
        </div>
        
        
        <Switch>
            <Route exact path='/home' render={ (renderProps) => 
                  (<GraphWaterController {...renderProps} uiConfig={this.uiConfig} signedIn={this.props.signedIn} user={this.props.user}/>)}/>
            <Route exact path='/home/electric' render={ (renderProps) => 
                  (<GraphController {...renderProps} uiConfig={this.uiConfig} signedIn={this.props.signedIn} user={this.props.user}/>)}/>
            <Route exact path='/home/gas' render={ (renderProps) => 
                  (<GraphGasController {...renderProps} uiConfig={this.uiConfig} signedIn={this.props.signedIn} user={this.props.user}/>)}/>
        </Switch>

      </div>
    )
  }
}